import { Component, Input, OnInit, OnDestroy, ElementRef, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-youtube-player',
  templateUrl: './youtube-player.component.html',
  styleUrls: ['./youtube-player.component.scss'],
  standalone: false
})
export class YoutubePlayerComponent implements OnInit, OnDestroy {
  @Input() videoId!: string;
  @Input() startSeconds?: number;
  @Input() autoplay: boolean = false;

  private apiLoaded = false;

  constructor(
    private dialogService: MatDialog,
    private elementRef: ElementRef<HTMLDivElement>,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    if (!this.apiLoaded) {
      // This code loads the IFrame Player API code asynchronously
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.body.appendChild(tag);
      this.apiLoaded = true;
    }
  }

  ngOnDestroy(): void {
    // Cleanup
  }

  /**
   * Extract video ID from YouTube URL if full URL is provided instead of just the ID
   */
  public getVideoId(): string {
    if (!this.videoId) {
      return '';
    }

    // If it's already just an ID (not a URL), return it
    if (!this.videoId.includes('/') && !this.videoId.includes('youtube') && !this.videoId.includes('youtu.be')) {
      return this.videoId;
    }

    // Extract from URL formats like:
    // https://www.youtube.com/watch?v=VIDEO_ID
    // https://youtu.be/VIDEO_ID
    // https://www.youtube.com/embed/VIDEO_ID

    let id = '';
    try {
      const urlObj = new URL(this.videoId);

      if (this.videoId.includes('youtube.com/watch')) {
        id = urlObj.searchParams.get('v') || '';
      } else if (this.videoId.includes('youtu.be/')) {
        id = this.videoId.split('youtu.be/')[1];
      } else if (this.videoId.includes('/embed/')) {
        id = this.videoId.split('/embed/')[1];
      }
    } catch (e) {
      return this.videoId; // Return as is if URL parsing fails
    }

    // Remove any additional parameters
    return id.split('?')[0].split('&')[0];
  }
}
